import React from "react";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ToolTip } from "@src/components/atoms/tooltip/tooltip";

import warningIconOutlined from "@src/assets/svg/warning-icon-outlined.svg";
import styles from "./blueprint-unassigned-warning-ignore-button-wrapper.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "blueprint-unassigned-warning-ignore-button-wrapper";

export const BlueprintUnassignedWarningIgnoreButtonWrapper = () => {
  const i18n = useI18N();

  const texts = {
    warningMessage: i18n(
      "modules.blueprintUnassignedWarningIgnoreButtonWrapper.warningMessage",
    ),
    warningIconAltText: i18n(
      "modules.blueprintUnassignedWarningIgnoreButtonWrapper.warningIconAltText",
    ),
    buttonIgnoreText: i18n(
      "modules.blueprintUnassignedWarningIgnoreButtonWrapper.buttonIgnoreText",
    ),
  };
  return (
    <FlexRowContainer>
      <FlexRowContainer>
        <div
          className={styles[`${cssClassName}__warning-icon-wrapper-tooltip`]}
        >
          <ToolTip content={texts.warningMessage} position="top-left">
            <img src={warningIconOutlined} alt={texts.warningIconAltText} />
          </ToolTip>
        </div>
        <div className={styles[`${cssClassName}__warning-icon-wrapper`]}>
          <img src={warningIconOutlined} alt={texts.warningIconAltText} />
        </div>
        <p className={styles[`${cssClassName}__text`]}>
          {texts.warningMessage}
        </p>
      </FlexRowContainer>
      <Button
        fun={() => ({})}
        text={texts.buttonIgnoreText}
        variant={"secondary"}
      />
    </FlexRowContainer>
  );
};
